<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-nav>
      <glxy-page-nav-button [useHistory]="true" (click)="navigateToPreviousPage()"></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>{{ 'MEETING_DETAILS.MEETING_DETAILS' | translate }}</glxy-page-title>
    @if (errorType() === 'none' && conversation() !== undefined) {
      <glxy-page-actions>
        <button mat-flat-button color="primary" (click)="popShareModal()" data-action="clicked-share-meeting">
          {{ 'COMMON.SHARE' | translate }}
        </button>
      </glxy-page-actions>
    }
  </glxy-page-toolbar>
  <glxy-page-wrapper>
    @if (conversation() === undefined) {
      <div class="loading-container">
        <glxy-loading-spinner></glxy-loading-spinner>
      </div>
    } @else if (errorType() === 'not-found') {
      <div class="wrapper">
        <glxy-page-not-found-404
          size="normal"
          icon="find_in_page"
          title="MEETING_DETAILS.MEETING_NOT_FOUND"
          subtitle="MEETING_DETAILS.MEETING_NOT_FOUND_DESCRIPTION"
        />
      </div>
    } @else if (errorType() === 'permission-denied') {
      <div class="wrapper">
        <glxy-page-not-found-404
          size="normal"
          icon="lock_outline"
          title="MEETING_DETAILS.PERMISSION_REQUIRED"
          subtitle="MEETING_DETAILS.PERMISSION_REQUIRED_DESCRIPTION"
      />
      </div>
    } @else {
    <div class="meeting-page-v2">
      <div class="header">
        <div class="meeting-details">
          <h2>{{ conversation()?.title || '' }}</h2>
          <div class="details">
            <span class="spacer">{{ conversation()?.meetingDate | date: 'MMMM d, yyyy' }}</span
            >|
            <span class="spacer">
              <meeting-analysis-start-and-end [conversation]="conversation()"></meeting-analysis-start-and-end>
            </span
            >|
            <span class="spacer visibility" (click)="popShareModal()">
              <meeting-analysis-visibility [conversation]="conversation()"></meeting-analysis-visibility>
            </span>
          </div>
          <div class="guests">
            <meeting-analysis-guests
              [contactIds]="externalAttendeesContactIds()"
              [userIds]="internalAttendees()"
              (jumpToGuestsTab)="switchToGuestsTab()"
            ></meeting-analysis-guests>
          </div>
          <div class="scores">
            <span class="spacer">
              {{ 'COMMON.RAVEN' | translate }}
              @if (conversation()?.salesMethodology?.ravenFramework?.totalScore !== undefined && conversation()?.salesMethodology?.ravenFramework?.totalScore !== null) {
                <meeting-analysis-score-badge
                  [score]="conversation()?.salesMethodology?.ravenFramework?.totalScore"
                  [maxScore]="25"
                ></meeting-analysis-score-badge>
              } @else {
                <span class="empty-score">{{ 'COMMON.NONE_FOUND' | translate }}</span>
              }
            </span>
            |
            <span class="spacer">
              {{ 'COMMON.SENTIMENT' | translate }}
              @if (conversation()?.interactionReport?.sentimentScore !== undefined && conversation()?.interactionReport?.sentimentScore !== null) {
                <meeting-analysis-score-badge
                  [score]="conversation()?.interactionReport?.sentimentScore"
                  [maxScore]="10"
                ></meeting-analysis-score-badge>
              } @else {
                <span class="empty-score">{{ 'COMMON.NONE_FOUND' | translate }}</span>
              }
            </span>
          </div>
        </div>
        <ng-container *ngIf="recordingURL$ | async as recordingUrl; else loadingRecording">
          <ng-container *ngIf="timeStamp$ | async as timeStamp">
            <video class="recording" controls preload #videoPlayer>
              <source [src]="recordingUrl + '#t=' + timeStamp" type="video/mp4"/>
              {{ 'RECORDING.VIDEO_NOT_SUPPORTED' | translate }}
            </video>
          </ng-container>
        </ng-container>
        <ng-template #loadingRecording>
          <div class="recording stencil-shimmer"></div>
        </ng-template>
      </div>
      <div class="body">
        <mat-tab-group
          [(selectedIndex)]="tabIndex"
          mat-stretch-tabs="false"
          mat-align-tabs="start"
          animationDuration="0ms"
          [ngClass]="{'smb-tab-group': context === Context.SMB, 'partner-tab-group': context === Context.PARTNER }"
        >
          <mat-tab label="{{ 'COMMON.SUMMARY' | translate }}" data-action="clicked-summary-tab">
            <meeting-analysis-summary
              [conversation]="conversation()"
              (timeStampSelected)="onTimeStampSelected($event)"
            ></meeting-analysis-summary>
          </mat-tab>
          <mat-tab label="{{ 'COMMON.AI_INSIGHTS' | translate }}" data-action="clicked-ai-insights-tab">
            <ng-template matTabContent>
              <meeting-analysis-insights
                [conversation]="conversation()"
                (jumpToTimestamp)="onTimeStampSelected($event)"
              ></meeting-analysis-insights>
            </ng-template>
          </mat-tab>
          <mat-tab label="{{ 'COMMON.GUESTS' | translate }}" data-action="clicked-guests-tab">
            <mat-card>
              <mat-card-header>
                <mat-card-title>
                  {{ ('COMMON.CONTACTS' | translate) + ' (' + (externalAttendeesContactIds()?.length || 0) + ')' }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <meeting-analysis-participants
                  [contactIds]="externalAttendeesContactIds()"
                  [large]="true"
                ></meeting-analysis-participants>
              </mat-card-content>
            </mat-card>
            <mat-card>
              <mat-card-header>
                <mat-card-title>
                  {{ ('MEETING_DETAILS.TEAM_MEMBERS' | translate) + ' (' + (internalAttendees()?.length || 0) + ')' }}
                </mat-card-title>
              </mat-card-header>
              <mat-card-content>
                <meeting-analysis-attendees
                  [userIds]="internalAttendees()"
                  [large]="true"
                  [host]="conversation()?.hostUserId"
                  [creator]="conversation()?.creatorUserId"
                ></meeting-analysis-attendees>
              </mat-card-content>
            </mat-card>
          </mat-tab>
          <mat-tab label="{{ 'COMMON.TRANSCRIPT' | translate }}" data-action="clicked-transcript-tab">
            @if (conversation()?.transcriptEntries?.length > 0) {
              <meeting-analysis-meeting-transcript
                [transcriptEntries]="conversation()?.transcriptEntries || []"
                (timeStampSelected)="onTimeStampSelected($event)"
                [conversationId]="conversation()?.id || ''"
              ></meeting-analysis-meeting-transcript>
            } @else {
              <div class="no-transcript">
                <glxy-empty-state>
                  <glxy-empty-state-hero>
                    <mat-icon class="larger-icon">text_snippet</mat-icon>
                  </glxy-empty-state-hero>
                  <glxy-empty-state-title
                  >{{ 'TRANSCRIPT.TRANSCRIPT_NOT_AVAILABLE_TITLE' | translate }}
                  </glxy-empty-state-title>
                  <p>{{ 'TRANSCRIPT.TRANSCRIPT_NOT_AVAILABLE_DESCRIPTION' | translate }}</p>
                </glxy-empty-state>
              </div>
            }
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
    }
  </glxy-page-wrapper>
</glxy-page>
